<template>
  <input
    type="file"
    v-show="false"
    ref="uploadInput"
    :accept="acceptFilter"
    @change="onUpload"
  />
</template>

<script>
import axios from "axios";

import MediaAPI from "@/api/media";

export default {
  props: {
    resourceType: {
      type: String,
      default: "misc",
    },
    acceptFilter: {
      type: String,
      default: ".jpg,.png,.gif,.svg,.jpeg,.webp,.avi,.mp4,.3gp,.mpeg,.mov",
    },
    sizeLimit: {
      type: Number,
      default: 20 * 1024 * 1024,
    },
  },
  methods: {
    showUploadDialog() {
      this.$refs.uploadInput.click();
      window.addEventListener("focus", this.onBodyFocused);
    },
    onBodyFocused() {
      if (!this.$refs.uploadInput.files[0]) {
        this.$emit("cancel");
        this.$refs.uploadInput.value = "";
      }

      window.removeEventListener("focus", this.onBodyFocused);
    },
    onUpload() {
      let file = this.$refs.uploadInput.files[0];

      if (!file) return;

      if (file.size > this.sizeLimit) {
        alert(this.$t("alerts.file_too_large"));
        this.$refs.uploadInput.value = "";
        return;
      }

      const fileType = file.type;

      MediaAPI.generateUploadUrl(this.resourceType, fileType).then(
        (signData) => {
          const upload_url = signData.upload_url;

          const formData = new FormData();
          // formData.append("Content-Type", fileType);
          formData.append("file", file);

          this.$emit("startedUpload");

          axios({
            method: "PUT",
            url: upload_url,
            data: formData.get("file"),
            headers: {
              "Content-Type": fileType,
            },
          })
            .then((data) => {
              this.$emit("uploaded", signData.cdn_url, {
                filename: file.name,
                size: file.size,
                type: fileType,
              });

              this.$refs.uploadInput.value = "";
            })
            .catch((err) => {
              console.error(err);
              this.$emit("error");
            });
        }
      );
    },
  },
};
</script>

<style>
</style>